import moment from "moment";
export const getRepaymentExpectedDateBy = (epoch) => {
    const date = moment(epoch);
    const day = date.date();
    let suffix;
    if (day > 3 && day < 21) {
        suffix = 'th';
    }
    else {
        switch (day % 10) {
            case 1:
                suffix = "st";
                break;
            case 2:
                suffix = "nd";
                break;
            case 3:
                suffix = "rd";
                break;
            default: suffix = "th";
        }
    }
    const formattedDate = date.format("D") + suffix + " " + date.format("MMMM");
    return formattedDate;
};
